import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CategoryService } from 'src/app/_services/category.service';

@Component({
  selector: 'app-addcategory',
  templateUrl: './addcategory.component.html',
  styleUrls: ['./addcategory.component.css']
})
export class AddcategoryComponent implements OnInit {

  submitted=false;
   definitionForm:FormGroup;

   @Input() hammadde:any;
   constructor(
     private formBuilder:FormBuilder,
     private activeModal:NgbActiveModal,
     private hammaddeService:CategoryService,
    
     private toastr: ToastrService
     
   ) { }
 
   ngOnInit() {
 
    this.definitionForm = this.formBuilder.group({
      name: ['', Validators.required],
      nameEnglish:[''],
      productType: [''],
      productTypeEnglish: [''],
      a: [''],
      aunit: [''],
      aunitEnglish: [''],
      applicationRegion: [''],
      applicationRegionEnglish: [''],
      contactAreaCm2: [''],
      amountPerApplicationGrams: [''],
      durationFrequency: [''],
      durationFrequencyEnglish: [''],
      foreseeable: [''],
      foreseeableEnglish: [''],
      targetGroup: [''],
      targetGroupEnglish: [''],



      bodyWeight: [''],
function: [''],
functionEnglish: [''],
   reference: [''],
   referenceEnglish: [''],
     
   
   

   
    
    });
 
    this.definitionForm.patchValue({
      name: this.hammadde.name,
      nameEnglish: this.hammadde.nameEnglish,
      a: this.hammadde.a,
      aunit: this.hammadde.aunit, 
      aunitEnglish: this.hammadde.aunitEnglish,
      amountOfProduct: this.hammadde.amountOfProduct,
      dermalAbsorption: this.hammadde.dermalAbsorption,
      durationFrequency: this.hammadde.durationFrequency,
      durationFrequencyEnglish: this.hammadde.durationFrequencyEnglish,
      foreseeable: this.hammadde.foreseeable,
      foreseeableEnglish: this.hammadde.foreseeableEnglish,
      retentionFactor: this.hammadde.retentionFactor,
      site: this.hammadde.site,
      surfaceArea: this.hammadde.surfaceArea,
      productType: this.hammadde.productType,
      productTypeEnglish: this.hammadde.productTypeEnglish,
      applicationRegion: this.hammadde.applicationRegion,
      applicationRegionEnglish: this.hammadde.applicationRegionEnglish,
      contactAreaCm2: this.hammadde.contactAreaCm2,
      amountPerApplicationGrams: this.hammadde.amountPerApplicationGrams,
      contactDurationAndFrequency: this.hammadde.contactDurationAndFrequency,
      exposureRoute: this.hammadde.exposureRoute,
      targetGroup: this.hammadde.targetGroup,
      targetGroupEnglish: this.hammadde.targetGroupEnglish,
      bodyWeight: this.hammadde.bodyWeight,
      function: this.hammadde.function,
      functionEnglish: this.hammadde.functionEnglish,
      reference: this.hammadde.reference,
      referenceEnglish: this.hammadde.referenceEnglish
    });
   }
 
 
   close(){
     this.activeModal.close();
   }
 
 
   save(){
     if(!this.definitionForm.valid){
       this.definitionForm.markAllAsTouched();
      
       return;
     }
     this.submitted=true;
 
 
     const model = {
      name: this.definitionForm.get("name")?.value,
      nameEnglish: this.definitionForm.get("nameEnglish")?.value,
      a: this.definitionForm.get("a")?.value,
      aunit: this.definitionForm.get("aunit")?.value,
      aunitEnglish: this.definitionForm.get("aunitEnglish")?.value,
      amountOfProduct: this.definitionForm.get("amountOfProduct")?.value,
      dermalAbsorption: this.definitionForm.get("dermalAbsorption")?.value,
      durationFrequency: this.definitionForm.get("durationFrequency")?.value,
      durationFrequencyEnglish: this.definitionForm.get("durationFrequencyEnglish")?.value,
      foreseeable: this.definitionForm.get("foreseeable")?.value,
      foreseeableEnglish: this.definitionForm.get("foreseeableEnglish")?.value,
      retentionFactor: this.definitionForm.get("retentionFactor")?.value,
      site: this.definitionForm.get("site")?.value,
      surfaceArea: this.definitionForm.get("surfaceArea")?.value,
      productType: this.definitionForm.get("productType")?.value,
      productTypeEnglish: this.definitionForm.get("productTypeEnglish")?.value,
      applicationRegion: this.definitionForm.get("applicationRegion")?.value,
      applicationRegionEnglish: this.definitionForm.get("applicationRegionEnglish")?.value,
      contactAreaCm2: this.definitionForm.get("contactAreaCm2")?.value,
      amountPerApplicationGrams: this.definitionForm.get("amountPerApplicationGrams")?.value,
      contactDurationAndFrequency: this.definitionForm.get("contactDurationAndFrequency")?.value,
      exposureRoute: this.definitionForm.get("exposureRoute")?.value,
      targetGroup: this.definitionForm.get("targetGroup")?.value,
      targetGroupEnglish: this.definitionForm.get("targetGroupEnglish")?.value,
      bodyWeight: this.definitionForm.get("bodyWeight")?.value,
      function: this.definitionForm.get("function")?.value,
      functionEnglish: this.definitionForm.get("functionEnglish")?.value,
      reference: this.definitionForm.get("reference")?.value,
      referenceEnglish: this.definitionForm.get("referenceEnglish")?.value

    };
    
 
     if(this.hammadde){
       //update
       const updatedModel = { ...model, id: this.hammadde.id };
       this.hammaddeService.editCompounds(updatedModel,this.hammadde.id).subscribe(res=>{
         this.submitted=false;
         this.toastr.clear();
         this.toastr.success('', 'Kayıt güncelleme başarılı');
         this.definitionForm.reset();
      
       },err=>{
         this.toastr.error('', 'Kayıt güncelleme sırasında hata oluştu');
         this.submitted=false;
       });
     }
     else{
       //insert
       this.hammaddeService.addCompounds(model).subscribe(res=>{
         this.submitted=false;
         this.toastr.clear();
         this.toastr.success('', 'Kayıt başarılı');
         this.definitionForm.reset();
       
       },err=>{
         this.toastr.error('', 'Kayıt sırasında hata oluştu');
         this.submitted=false;
       });
     }
   
   }
 

 }
 